var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('MPGroup', {
    attrs: {
      "prop": _vm.data.template.prop,
      "data": _vm.data.dataSource.data
    }
  }, [_c('div', {
    staticClass: "mp-shops-map"
  }, [_vm.mapLink ? _c('GGLink', {
    staticClass: "mp-shops-map__link",
    attrs: {
      "to": _vm.mapLink
    }
  }, [_c('p', {
    staticClass: "link__title"
  }, [_vm._v("\n        Магазины "), _c('br'), _vm._v("\n        на карте\n      ")]), _vm._v(" "), _c('p', {
    staticClass: "link__desc"
  }, [_vm._v("Открыть карту")]), _vm._v(" "), _c('div', {
    staticClass: "link__pins"
  })]) : _vm._e(), _vm._v(" "), _c('MPRowSlider', {
    staticClass: "mp-shops-map__slider",
    attrs: {
      "list": _vm.data.dataSource.data.brand || []
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (_ref) {
        var _vm$data$dataSource$d, _el$image, _el$image2, _el$image3;

        var el = _ref.el,
            index = _ref.index;
        return [_c('GGLink', {
          attrs: {
            "to": el.path
          }
        }, [_c('div', {
          staticClass: "mp-shops-map__shop-card",
          class: {
            'mp-shops-map__shop-card_last': ((_vm$data$dataSource$d = _vm.data.dataSource.data.brand) === null || _vm$data$dataSource$d === void 0 ? void 0 : _vm$data$dataSource$d.length) && index === _vm.data.dataSource.data.brand.length - 1
          }
        }, [_c('img', {
          staticClass: "shop-card__logo",
          attrs: {
            "src": el === null || el === void 0 ? void 0 : (_el$image = el.image) === null || _el$image === void 0 ? void 0 : _el$image.x1,
            "srcset": (el === null || el === void 0 ? void 0 : (_el$image2 = el.image) === null || _el$image2 === void 0 ? void 0 : _el$image2.x2) && ((el === null || el === void 0 ? void 0 : (_el$image3 = el.image) === null || _el$image3 === void 0 ? void 0 : _el$image3.x2) + " 2x"),
            "alt": ("Логотип магазина " + (el.name))
          }
        }), _vm._v(" "), _c('div', {
          staticClass: "shop-card__text-wrapper"
        }, [_c('p', {
          staticClass: "shop-card__title"
        }, [_vm._v("\n              " + _vm._s(el.name) + "\n            ")]), _vm._v(" "), el.description ? _c('p', {
          staticClass: "shop-card__description"
        }, [_vm._v("\n              " + _vm._s(el.description) + "\n            ")]) : _vm._e()])])])];
      }
    }])
  })], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }